import { IEventWasDeleted } from '../../../actions/bookingCalendar/event/requestDeleteEvent'
import { IEventsStore } from '../../events'

export default function(
  state: IEventsStore,
  action: IEventWasDeleted,
): IEventsStore {
  return {
    ...state,
    events: state.events.map(event =>
      event.id === action.eventId ? { ...event, isDeleted: true } : event,
    ),
  }
}
